(function () {
  const FEE_HANDLE = "order-handling-fee"; // <-- change if your handle is different
  const LOCK_QUANTITY = 1;

  async function fetchCart() {
    const r = await fetch("/cart.js", { credentials: "same-origin" });
    return r.json();
  }

  async function fetchProductByHandle(handle) {
    const r = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
    if (!r.ok) return null;
    return r.json();
  }

  async function addVariantToCart(variantId, qty) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
  }

  async function setLineItemQuantity(lineKey, qty) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: lineKey, quantity: qty })
    });
  }

  async function ensureHandlingFee() {
    const cart = await fetchCart();

    // If cart empty, do nothing
    if (!cart.items || cart.items.length === 0) return;

    // Identify fee line (if present)
    const feeLine = cart.items.find(i => i.handle === FEE_HANDLE);

    // Determine if there are any "real" items besides the fee
    const hasRealItems = cart.items.some(i => i.handle !== FEE_HANDLE);

    // If only fee is in cart, remove it
    if (!hasRealItems && feeLine) {
      await setLineItemQuantity(feeLine.key, 0);
      return;
    }

    // If real items exist but fee not present, add it
    if (hasRealItems && !feeLine) {
      const product = await fetchProductByHandle(FEE_HANDLE);
      if (!product || !product.variants || !product.variants.length) return;
      await addVariantToCart(product.variants[0].id, LOCK_QUANTITY);
      return;
    }

    // If fee is present, force it to quantity 1 (prevents multi qty)
    if (feeLine && feeLine.quantity !== LOCK_QUANTITY) {
      await setLineItemQuantity(feeLine.key, LOCK_QUANTITY);
    }
  }

  // Run on page load
  document.addEventListener("DOMContentLoaded", () => {
    ensureHandlingFee().catch(() => {});
  });

  // Re-run after cart updates (Dawn cart drawer + cart page)
  document.addEventListener("cart:refresh", () => {
    ensureHandlingFee().catch(() => {});
  });

  // Fallback: watch for common Dawn cart activity
  document.addEventListener("click", (e) => {
    const el = e.target.closest('button, a, input');
    if (!el) return;

    // after common cart actions, re-check shortly
    const triggers = [
      '[name="plus"]',
      '[name="minus"]',
      'a[href*="/cart"]',
      'button[type="submit"]'
    ];

    if (triggers.some(sel => el.matches(sel) || el.closest(sel))) {
      setTimeout(() => ensureHandlingFee().catch(() => {}), 700);
    }
  });
})();
